import { Injectable, OnDestroy } from '@angular/core';
import { DataFilters, DataFiltersService } from './data-filters.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SelectorCity } from '../models/region-selection-cities.model';
import { CityRegion } from '../models/region-model';
@Injectable()
export class CitiesService implements OnDestroy {
  public dataFilters: DataFilters = new DataFilters();
  private ngUnsubscribe: Subject<void> = new Subject();
  public getConsumerSpending$ = new Subject<{
    startYear: number;
    endYear: number;
    city: string;
  }>();
  public getCitiyAgeAndGender$ = new Subject<{ city: string }>();
  public citiesList$ = new Subject<SelectorCity[]>();
  public citiesMapList$ = new Subject<SelectorCity[]>();
  public getCities$ = new Subject<
    | {
        continentCode: string;
        countryCode: string;
      }
    | undefined
  >();
  public getCitiesOnHover$ = new Subject<
    | {
        continentCode: string;
        countryCode: string;
      }
    | undefined
  >();
  public getCountries$ = new Subject<{ continent: CityRegion }>();
  public getCitySpendingDistribution$ = new Subject<{ city: string }>();

  constructor(private dataFiltersService: DataFiltersService) {
    this.dataFiltersService
      .getDataFilters()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((filters) => {
        this.dataFilters = filters;
      });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
